// useMakeRequest.js
import { useState, useEffect } from "react";

const useMakeRequest = (endpoint) => {
  const [result, setResult] = useState({
    data: [],
    error: null,
    isLoading: true,
  });

  useEffect(() => {
    const asyncFunc = async () => {
      try {
        const response = await fetch(endpoint, {
          mode: 'cors',
          headers: {
            'Authorization': `Bearer ${process.env.REACT_APP_SECRET_TOKEN}`,
          },
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const json = await response.json();
        setResult({ data: json, error: null, isLoading: false });
      } catch (error) {
        setResult({ data: [], error: error.message, isLoading: false });
      }
    };

    asyncFunc();
  }, [endpoint]);

  return result;
};

export default useMakeRequest;